import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  UpdateOrderDriverAndVehicleActions as Actions,
  UpdateOrderDriverAndVehicleRequestAction as RequestAction,
} from 'store/ducks/orders';

export function* updateOrderDriverAndVehicleRequest(action: any) {
  const { id, putData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.put, `orders/${id}/driver-and-vehicle`, putData);
    onSuccess && onSuccess();
    notify('success', 'Solicitações de estoque atualizadas com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
